import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeSemanticSearchModalSize} from "./get_semantic_search_modal_size";

export const trackAmplitudeSubmitAiQuestion = (modalSize: AmplitudeSemanticSearchModalSize, analyticSessionId: string | null | undefined) => {
    trackAmplitudeEvent("submit_ai_question", {
        analytic_session_id: analyticSessionId ?? null,
        modal_size: modalSize
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeSemanticSearchModalSize} from "./get_semantic_search_modal_size";

export const trackAmplitudeSubmitAiQuestion = (modalSize: AmplitudeSemanticSearchModalSize, analyticSessionId: string | null | undefined) => {
    trackAmplitudeEvent("submit_ai_question", {
        analytic_session_id: analyticSessionId ?? null,
        modal_size: modalSize
    });
};
